import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnNE: CultureInfo = {
  name: 'ff-Latn-NE',
  displayName: 'Pulaar (Latn, Nijeer)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-NE',
  parent: CultureInfoFfLatn
};
